import { TimePicker as AntdTimePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { Form } from 'react-bootstrap'

export default function TimePicker(props) {

    const { label_name, placeholder, name, value, onChange, onBlur, error, mandatory, reference, tabIndex } = props

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className='form_label'>{label_name}{mandatory ? <span style={{ color: 'red' }}>*</span> : ''}</Form.Label>}
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                borderColor: 'hsl(0, 0%, 80%)',
                                activeBorderColor: '#436a53',
                                activeOutlineColor: 'none',
                                hoverBorderColor: 'none',
                                hoverBg: 'transparent',
                                activeShadow: 'none',
                                activeBg: 'transparent',
                                zIndexPopup: '99999'
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Lexend Deca'
                        },
                    }}
                >
                    <AntdTimePicker
                        ref={reference}
                        key={value}
                        className='form-control form_input'
                        placeholder={placeholder}
                        format={"HH:mm"}
                        name={name}
                        defaultValue={value ? dayjs(value, 'HH:mm') : ''}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                        needConfirm={false}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
